<template>
  <div class="combobox-container">
    <div class="input-wrapper">
      <span class="icon-location">📍</span>
      <input
        ref="searchInput"
        v-model="searchQuery"
        @input="handleInput"
        @focus="showSuggestions = true"
        @blur="onBlur"
        placeholder="Buscar: Lima, Arequipa, Miraflores..."
      />
      <span 
        v-if="searchQuery" 
        class="icon-clear"
        @click="clearSearch"
      >×</span>
    </div>
    
    <ul v-show="showSuggestions && filteredOptions.length" class="suggestions">
      <li 
        v-for="(option, index) in filteredOptions"
        :key="index"
        @mousedown.prevent="selectOption(option)"
        v-html="highlightMatch(option)"
      ></li>
    </ul>
    
    <div v-if="selectedOption" class="preview">
      <span class="label">Ubicación seleccionada:</span>
      <div class="selected-value">{{ selectedOption }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    value: String
  },
  data() {
    return {
      searchQuery: '',
      showSuggestions: false,
      selectedOption: this.value,
      allOptions: []
    }
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery) return [];
      const query = this.searchQuery.toLowerCase().trim();
      
      return this.allOptions
        .filter(option => {
          // Buscar en cada parte (departamento, provincia, distrito)
          const parts = option.toLowerCase().split(' > ');
          return parts.some(part => part.includes(query));
        })
        .slice(0, 8); // Limitar resultados
    }
  },
  methods: {
    clearSearch() {
      this.selectOption(null); // Reutilizamos la lógica
      this.focusInput();
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    handleInput() {
      this.showSuggestions = true;
      this.$emit('input', this.searchQuery);
    },
    onBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    selectOption(option) {
      if (!option) {
        this.selectedOption = '';
        this.searchQuery = '';
        this.$emit('input', '');
        this.$emit('change', {
          departamento: null,
          provincia: null,
          distrito: null
        });
        return;
      }
      
      this.selectedOption = option;
      this.searchQuery = option;
      this.$emit('input', option);
      
      const [departamento, provincia, distrito] = option.split(' > ');
      this.$emit('change', {
        departamento,
        provincia,
        distrito
      });
    },
    highlightMatch(text) {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) return text;
      
      const parts = text.split(' > ');
      const highlightedParts = parts.map(part => {
        const index = part.toLowerCase().indexOf(query);
        if (index >= 0) {
          return (
            part.substring(0, index) +
            `<span class="highlight">${part.substring(index, index + query.length)}</span>` +
            part.substring(index + query.length)
          );
        }
        return part;
      });
      
      return highlightedParts.join(' > ');
    },
    extractLocationData(fullLocation) {
      const [departamento, provincia, distrito] = fullLocation.split(' > ');
      return { departamento, provincia, distrito };
    },
    processOptions() {
      this.allOptions = this.options.map(opt => {
        const [d, p, dist] = opt.split(' > ');
        return `${d} > ${p} > ${dist}`;
      });
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.selectedOption) {
        this.selectedOption = newVal;
        this.searchQuery = newVal || '';
      }
    },
    options: {
      immediate: true,
      handler() {
        this.processOptions();
      }
    }
  }
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.icon-location {
  position: absolute;
  left: 10px;
  z-index: 2;
  font-size: 1.2em;
}

.icon-clear {
  position: absolute;
  right: 10px;
  z-index: 2;
  font-size: 1.4em;
  cursor: pointer;
  color: #999;
  padding: 0 5px;
  transition: color 0.2s;
}

.icon-clear:hover {
  color: #333;
}

input {
  padding: 10px 35px 10px 35px !important;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95em;
}
.combobox-container {
  position: relative;
  margin: 15px 0;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.icon {
  position: absolute;
  left: 10px;
  z-index: 2;
  font-size: 1.2em;
}

input {
  padding: 10px 15px 10px 35px !important;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95em;
}

.suggestions {
  position: absolute;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-top: none;
  background: white;
  z-index: 1000;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border-radius: 0 0 4px 4px;
}

.suggestions li {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.9em;
  transition: background 0.2s;
}

.suggestions li:hover {
  background-color: #f8f8f8;
}

.suggestions li:last-child {
  border-bottom: none;
}

.highlight {
  background-color: #fff9c4;
  font-weight: 600;
  color: #333;
}

.preview {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-size: 0.85em;
}

.preview .label {
  display: block;
  color: #666;
  margin-bottom: 3px;
  font-size: 0.9em;
}

.preview .selected-value {
  font-weight: 500;
  color: #333;
}

/* Efecto de enfoque */
input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
</style>